import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[fiveDigitDecimaNumber]',
  standalone: false
})
export class FiveDigitDecimaNumberDirective {
  // Allow decimal numbers and negative values
  private readonly regex: RegExp = new RegExp(/^\d*\.?\d{0,5}$/g);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private readonly specialKeys: string[] = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
    'Enter'
  ];

  constructor(private readonly el: ElementRef) {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.includes(event.key)) {
      event.stopPropagation();
      return;
    }
    this.regex.lastIndex = 0;
    if (
      this.el.nativeElement.value &&
      !this.regex.exec(String(this.el.nativeElement.value))
    ) {
      if (isNaN(this.el.nativeElement.value) && !isNaN(Number(event.key))) {
        this.el.nativeElement.value = event.key;
        event.preventDefault();
        return;
      }
      event.stopPropagation();
      return;
    }
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key === 'Decimal' ? '.' : event.key,
      current.slice(position)
    ].join('');
    this.regex.lastIndex = 0;
    // eslint-disable-next-line
    if (next && this.regex.exec(String(next))) {
      this.el.nativeElement.value = next;
    } else {
      this.el.nativeElement.value = current;
    }
    event.preventDefault();
  }
}
